import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { environment } from '../../../environments/environment';
import { appVariables } from '../constants/Common.constant';
import { UserModel } from '../models/ShoppingCart.model';

import { CartItemsModel } from '../../core/models/ShoppingCart.model';


function getWindow(): any {
  return window;
}

@Injectable()
export class HelperService {
  addContentTypeHeader: boolean | string = true;
  env: string;
  private Loading = new BehaviorSubject(false);
  observeLoading = this.Loading.asObservable();
  LoadingCounter = 0;
  constructor() {
    this.env = environment.env;
  }


  isProdEnv(): boolean {
    return (this.env.toLocaleLowerCase() === 'prod' ||
      this.env.toLocaleLowerCase() === 'production') ? true : false;
  }
  isStageEnv(): boolean {
    return (this.env.toLocaleLowerCase() === 'prod' ||
      this.env.toLocaleLowerCase() === 'production') ? true : false;
  }
  isDevEnv(): boolean {
    return (this.env.toLocaleLowerCase() === 'dev' ||
      this.env.toLocaleLowerCase() === 'development') ? true : false;
  }

  setToLocalStorage(key: string, value: string) {
    localStorage.setItem(key, value);
  }
  getFromLocalStorage(KeyName) {
    return localStorage.getItem(KeyName) == null ? '' : localStorage.getItem(KeyName);
  }
  getUserFromLocalStorage(): UserModel {
    const user = this.getFromLocalStorage(appVariables.userLocalStorage);
    if (user !== '') {
      return <UserModel>JSON.parse(user);
    } else {
      return new UserModel();
    }
  }

  setUserToLocalStorage(userModel: UserModel) {
    this.setToLocalStorage(appVariables.userLocalStorage, JSON.stringify(userModel));
    this.setToLocalStorage(appVariables.accessTokenLocalStorage, userModel.token ? userModel.token : '');
    // this.setToLocalStorage(appVariables.accessAppID, userModel.AppID);
    this.setToLocalStorage(appVariables.addressMode, 'false');
  }

  backToSite(AppUrl) {
    // ? '?token='+ (this.getFromLocalStorage(appVariables.accessTokenLocalStorage)
    // + this.getFromLocalStorage(appVariables.accessTokenLocalStorage) : '' )

    if (AppUrl) {
      window.location.href = this.generateRedirectionLink(AppUrl);
      const PromoCode = this.getFromLocalStorage(appVariables.promoCode);
      this.signOutUser();
      this.setToLocalStorage(appVariables.promoCode, PromoCode);
    }
  }

  generateRedirectionLink(AppUrl) {
    if (this.getFromLocalStorage(appVariables.accessAppID) != '5') {
      return AppUrl + environment.appConfig['5'].UrlSufix;
    } else {
      return AppUrl + environment.appConfig[this.getFromLocalStorage(appVariables.accessAppID)].UrlSufix;
    }
  }

  startLoader() {
    this.LoadingCounter += 1;
    this.Loading.next(true);
  }
  stopLoader() {
    this.LoadingCounter -= 1;
    if (this.LoadingCounter <= 0) {
      this.Loading.next(false);
    }
  }
  signOutUser() {
    localStorage.clear();
    // window.location.href = appVariables.loginPageUrl;
  }

  IsSpecialCharacterAvailable(value) {
    let pattern = new RegExp(/[~`!#@$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/); //unacceptable chars
    return pattern.test(value)
    //  return !/[~`!#$%\^&*+=\-\[\]\\';,/{}|\\":<>\?]/g.test(value);
  }
  validateCreditCardName(value){
    let pattern = new RegExp(/^[ a-z0-9\-\'\.]+$/i);
    return pattern.test(value)
  }
  validateName(value) {
    // allow only alphabet, periods, apostrophes, hyphens 
    let pattern = new RegExp(/^[ a-z\-\'\.]+$/i);
    return pattern.test(value)
  }
  hasNumbers(value) {
    return /\d/.test(value);
  }
//LMM-5209 changes start
CheckProductStockAvailable(CartItemsList: CartItemsModel[] ):boolean
{
  let isStockAvailable=true;
  CartItemsList.forEach(element => {
    if(isStockAvailable)
    {
      isStockAvailable = element.IsStockAvailable;
    }
  });
  return isStockAvailable;
}
//LMM-5209 changes end

IsEmailPatternValid(emailControl: string) {
  let isValid = /^[a-zA-Z0-9._'-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,}$/.test(emailControl);
  if (isValid) {
    return true;
  } else {
    return false
  };
}

}



// WEBPACK FOOTER //
// ./src/app/core/services/helper.service.ts